import { DeleteElementDocument, DeleteElementMutationVariables } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useDeleteElement = (formId: string) => {
  const [deleteElement, { loading }] = useMutation(DeleteElementDocument, {
    extractorFn: (data) => data.formsMutations.deleteFormsElement,
    update(cache, { data }) {
      const deletedElement = data?.formsMutations.deleteFormsElement.element
      if (!deletedElement) return

      const normalizedId = cache.identify({
        id: deletedElement.id,
        __typename: 'FormsElement',
      })

      // Remove reference from parent list
      cache.modify({
        id: `FormsForm:${formId}`,
        fields: {
          elements(existingRefs = [], { readField }) {
            return existingRefs.filter((ref: { __ref?: string }) => {
              if (!ref.__ref) return true
              const isTarget = ref.__ref === normalizedId
              const sectionId = readField('sectionId', ref)
              const isChildOfTarget = sectionId === deletedElement.id
              return !isTarget && !isChildOfTarget
            })
          },
        },
      })

      // Evict from the cache
      if (normalizedId) {
        cache.evict({ id: normalizedId })
        cache.gc()
      }
    },
  })

  return {
    loading,
    deleteElement(variables: DeleteElementMutationVariables) {
      return deleteElement({ variables })
    },
  }
}

export default useDeleteElement
